"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = require("./util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var step = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opts, cb) {
    var _gRef$current;

    var id, gRef, props, prevProps, dbg, onUnmountReceiver, instance, event, tick, componentProps, _yield$gRef$current$n, value;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = opts.id, gRef = opts.gRef, props = opts.props, prevProps = opts.prevProps, dbg = opts.dbg, onUnmountReceiver = opts.onUnmountReceiver;
            instance = (_gRef$current = gRef.current) === null || _gRef$current === void 0 ? void 0 : _gRef$current.id;
            event = dbg.event;
            (0, _util.logState)("Tick via ".concat(event), {
              id: id,
              instance: instance,
              props: props,
              prevProps: prevProps
            });

            tick = function tick() {
              return step(opts, cb);
            };

            componentProps = _objectSpread(_objectSpread({}, props), {}, {
              prevProps: prevProps,
              __dbg: dbg,
              tick: tick,
              withTick: function withTick(x) {
                return function () {
                  return x().then(tick);
                };
              },
              onUnmount: onUnmountReceiver
            });
            _context.next = 8;
            return gRef.current.next(componentProps);

          case 8:
            _yield$gRef$current$n = _context.sent;
            value = _yield$gRef$current$n.value;
            cb(value);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function step(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = step;
exports["default"] = _default;